import React from 'react';
import { Col } from 'reactstrap';
import FieldTitle from '../FieldTitle';
import { Field } from 'react-final-form';

const formColClass = 'px-2 py-1';
const lgColSize = 6;
const mdColSize = 12;

const EditPracticeFormField = (props) => {
    return (
        <Col lg={lgColSize} md={mdColSize} className={formColClass}>
            <FieldTitle {...props} />
            <Field
                className="w-100 p-2 rounded border"
                component="input"
                {...props}
            />
        </Col>
    );
};

export default EditPracticeFormField;
